export const GET_COMBO_CUA_HANG = "GET_COMBO_CUA_HANG";
export const GET_COMBO_CUA_HANG_SUCCESS = "GET_COMBO_CUA_HANG_SUCCESS";
export const GET_COMBO_CUA_HANG_FAILURE = "GET_COMBO_CUA_HANG_FAILURE";

export const CHUYEN_CUA_HANG = "CHUYEN_CUA_HANG";
export const CHUYEN_CUA_HANG_SUCCESS = "CHUYEN_CUA_HANG_SUCCESS";
export const CHUYEN_CUA_HANG_FAILURE = "CHUYEN_CUA_HANG_FAILURE";

export const THONG_TIN_CUA_HANG_HIEN_TAI = "THONG_TIN_CUA_HANG_HIEN_TAI";
export const THONG_TIN_CUA_HANG_HIEN_TAI_SUCCESS =
  "THONG_TIN_CUA_HANG_HIEN_TAI_SUCCESS";
export const THONG_TIN_CUA_HANG_HIEN_TAI_FAILURE =
  "THONG_TIN_CUA_HANG_HIEN_TAI_FAILURE";
